import { render } from "./FbnAdditionalInformation.vue?vue&type=template&id=01826d31"
import script from "./FbnAdditionalInformation.vue?vue&type=script&lang=js"
export * from "./FbnAdditionalInformation.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__